<template>
  <div>
    <el-row style="margin: 0px; height: 100%">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-container class="content">
          <el-header
            style="
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 1000;
            "
          >
            <div style="background-color: #ffffff">
              <Menu ref="refMenu"></Menu>
            </div>
          </el-header>
          <el-main>
            <router-view
              @toRedirect="toRedirect"
              res="resRouterView"
              style="padding-top: 49px"
            />
          </el-main>
          <el-footer>
            <Footer></Footer>
          </el-footer>
        </el-container>
      </el-col>
    </el-row>
    <Login />
  </div>
</template>

<script>
import Login from "./content/Login.vue";
import Menu from "./models/Menu";
import Footer from "./models/Footer";

export default {
  name: "index",
  components: {
    Menu,
    Footer,
    Login
  },
  mounted () {

  },
  methods: {
    toRedirect (value) {
      this.$refs.refMenu.toRedirect(value);
    },
  },
};
</script>

<style scoped>
.el-header,
.el-main,
.el-footer {
  padding: 0px;
}
.content {
}
</style>
